import API from "serviceshift-ui/api-client";
import pollResponse from "serviceshift-ui/shared/src/lib/pollResponse";

import { LoanProgram, VendorLoanOffers } from "@/Financing/types";

export default {
  async fetchLoanOffersForQuote(
    _,
    params: {
      customerId: number | string;
      quoteId: number | string;
      downPaymentAmountCents?: number;
    }
  ) {
    const downPaymentCents = params.downPaymentAmountCents || 0;
    return pollResponse(async () => {
      return (
        await API.makeRequest<{
          loading: boolean;
          data: VendorLoanOffers;
        }>(
          `/v2/customers/${params.customerId}/quotes/${params.quoteId}/financing_options?down_payment_cents=${downPaymentCents}`
        )
      ).data;
    });
  },
  async fetchLoanProgram(_, id: number | string) {
    const request = await API.makeRequest<LoanProgram>(`/loan_programs/${id}`);
    return request.data;
  },
  async updateLoanProgram(
    _,
    data: { id: string | number } & Partial<
      Pick<LoanProgram, "preferred_min_amount_cents">
    >
  ) {
    return API.makeRequest(`/loan_programs/${data.id}`, {
      method: "PATCH",
      data
    });
  },
  async activateLoanPrograms(
    _,
    params: { lender: string; programIds: number[] }
  ) {
    return API.makeRequest("/loan_programs/bulk_update", {
      method: "POST",
      data: {
        command: "activate",
        ids: params.programIds
      }
    });
  },
  async deactivateLoanPrograms(
    _,
    params: { lender: string; programIds: number[] }
  ) {
    return API.makeRequest("/loan_programs/bulk_update", {
      method: "POST",
      data: {
        command: "deactivate",
        ids: params.programIds
      }
    });
  },
  async refreshLoanPrograms(_, lender: string) {
    return pollResponse(
      async () => {
        const response = await API.makeRequest("/loan_programs/refresh", {
          method: "POST",
          data: { lender }
        });
        return response.data;
      },
      { maxTries: 15 }
    );
  }
};
